import {observer} from "mobx-react";
import React from "react";
import {
    ContentNew,
    ContentFilter, ContainerExplication, ContentExplication,
} from "./styled";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";


const SearchBar = observer(
    ({
         handleClickStartBackup
     }: {
        handleClickStartBackup: () => void,
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;


        return (
            <ContentFilter>
               <ContainerExplication>
                   <ContentExplication background={SharedColors.onAttendingStatus} color={SharedColors.textAttendingStatus}>
                       <DropDeskIcon
                           icon={ICONS_DROPDESK.info}
                           size={16}
                           style={{marginRight: 8}}
                           color={SharedColors.textAttendingStatus}
                       />
                       Atenção: Este backup contém dados sensíveis. Certifique-se de armazená-lo em local seguro. O processo de backup pode levar até 48 horas para ser concluído.
                       Para acessar o backup, utilize o e-mail principal da conta como senha. Assim que o backup for concluído, enviaremos um e-mail notificando..
                   </ContentExplication>

               </ContainerExplication>
                <ContentNew>
                     <ButtonNew
                        marginLeft={0}
                        isButtonMain={true}
                        label={'Realizar Backup'}
                        onClick={() => handleClickStartBackup()}
                        nameLeftIcon={''}
                        sizeLeftIcon={16}
                        disabled={false}
                    />

                </ContentNew>
            </ContentFilter>
        )
    })
export default SearchBar;
